<template>
  <div class="h-topo-treebox">
    <div class="h-gnb-pm-tree">
      <ejs-treeview id='pmGnbTopoTree' ref='pmGnbTopoTree' :nodeSelected="nodeSelectedOfPmGnbTopoTree" :nodeChecked="nodeSelectedOfPmGnbTopoTree" :enablePersistence='true' :showCheckBox='true' :fields='pmGnbTopoTreeFields'></ejs-treeview>
    </div>
  </div>
</template>
<script>

export default {
  name: 'BackupGnbTopoTree',
  data(){
    return {
      pmGnbTopoTreeFields: {
        dataSource: [],
        id: 'id',
        parentID: 'parentId',
        text: 'name',
        hasChildren: 'hasChildren',
        expanded: 'expanded'
      },
    }
  },
  methods: {

    // 网元树点击事件
    nodeSelectedOfPmGnbTopoTree(args) {
      console.log('nodeSelected')
     // const nodeInfo = this.$refs.pmGnbTopoTree.getTreeData(args.nodeData.id)[0];
     let  nodeInfo = [];

     args.data.forEach(node =>{

       if(node.isChecked == 'true' && node.text !== 'gnb'){
         let checked = {}
         checked.id = node.id;
         checked.name = node.text;
         nodeInfo.push(checked);
       }
     });
     if(nodeInfo === null || nodeInfo.length === 0){
        nodeInfo = null;
     }

      this.$emit('pmGnbTopoTreeClickEventPush', nodeInfo);
    },

    async getPmGnbTopoTree() {
      this.$axios.get('/lte/ems/pm/gnb/getPmGnbTopoTree.html').then((response) => {
        this.pmGnbTopoTreeFields = {
          dataSource: response.data.resultVal,
          id: 'id',
          parentID: 'parentId',
          text: 'name',
          hasChildren: 'hasChildren',
          expanded: 'expanded'
        };
      });
    },
  },
  mounted(){
  }
};
</script>
